import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';

export interface RISR {
    id_barragem?: string ;
    periodo_referencia: string;
    empresa_executora: string;
    data_inspecao: string;
    data_dce?: string;
    status_dce?: string;
    responsavel?: string;
    art?: string;
    orgao?: string;
    dpa?: string;
    cri?: string;
    classificacao?: string;
    uuid?: string;
    data_criacao?: string;
    verificacaoHidrologica: VerificacaoHidrologica;
    monitoramentos: Monitoramentos[];
    recomendacoes: Recomendacoes[];
    analiseEstabilidade: AnaliseEstabilidade;
    npgb: string
  }
  
  // export Interface for AnaliseEstabilidade
  export interface AnaliseEstabilidade {
    modos_falha?: string;
    metodo_analise?: string;
    informacoes: InfoAnalises[];
  }

  export interface InfoAnalises {
    secao?: string;
    condicao?: string;
    fator_seguranca?: string;
    valor_referencia?: string;
  }
  
  // export Interface for VerificacaoHidrologica
  export interface VerificacaoHidrologica {
    area_drenagem?: number;
    precipitacao_pmp?: number;
    precipitacao_projeto?: number;
    duracao_chuva?: number;
    vazao_maxima?: number;
    na_maximo_operacional?: number;
    na_maximo_maximorum?: number;
    borda_livre?: number;
    bombeamento?: number;
  }
  
  // export Interface for Monitoramentos
  export interface Monitoramentos {
    tipo?: string;
    destaque?: string;
  }

  // export Interface for Recomendacoes
  export interface Recomendacoes {
    recomendacao?: string;
    prazo?: string;
  }

const getAll = async (risr: string): Promise<RISR[] | Error> => {

    await AuthService.verify();

    try{
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get(`./risrs?uuid=${risr}`, {
            headers: {
                Authorization: `${token}`
            }
        });        

        if(response.data){
            return response.data;
        }

        return new Error('Erro ao buscar dados', response.data);
    } catch (error: any) {
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao buscar dados', error);
        }
    }
};

const get = async (risr: string): Promise<RISR | Error> =>{

    await AuthService.verify();

    try{
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get(`./risr?uuid=${risr}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data){
            return response.data;
        }

        return new Error('Erro ao buscar dados', response.data);
    } catch (error: any) {
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao buscar dados', error);
        }
    }
};

const create = async (data: RISR): Promise<string | Error> => {

    await AuthService.verify();

    try{
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.post('./risr', data, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data){
            return response.data;
        }

        return new Error('Erro ao buscar dados', response.data);

    }catch (error: any) {
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao buscar dados', error);
        }
    }

};

const upgrade = async (data: RISR, risr: string): Promise<string | Error> => {

    await AuthService.verify();

    try{
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.put(`./risr?uuid=${risr}`, data, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data){
            return response.data;
        }

        return new Error('Erro ao buscar dados', response.data);

    }catch (error: any) {
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao buscar dados', error);
        }
    }

};

export const ReportsServicesRisr = {
    getAll,
    get,
    create,
    upgrade
};
